import { render } from "./CreatureTableEntry.vue?vue&type=template&id=5a974cae"
import script from "./CreatureTableEntry.vue?vue&type=script&lang=js"
export * from "./CreatureTableEntry.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/acnh-tracker/acnh-tracker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__